export default __webpack_public_path__ + "files/debacb904ea0289fc5c6f40a3760c2f4.woff2";